import { useState } from "react";
import ModalDialog, {
  ModalDialogBody,
  ModalDialogFooter,
} from "../UI/ModalDialog";
import Button from "../UI/Button";
import Text from "../UI/Text";
import Callout from "../UI/Callout";
import { useToast } from "../UI/Toast/useToast";
// @ts-expect-error pure js
import { handleAPIError } from "../../utils";
import styles from "./RefuserCandidatModal.module.css";

interface RefuserCandidatModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: (notifyCandidat: boolean) => Promise<void>;
}

export default function RefuserCandidatModal({
  open,
  onOpenChange,
  onConfirm,
}: RefuserCandidatModalProps) {
  const toast = useToast();
  const [submitting, setSubmitting] = useState(false);

  async function confirm(notifyCandidat: boolean) {
    setSubmitting(true);
    try {
      await onConfirm(notifyCandidat);
      onOpenChange(false);
    } catch (error) {
      toast.error({
        title: "Impossible de refuser le dossier",
        description: handleAPIError(error),
      });
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <ModalDialog
      open={open}
      onOpenChange={onOpenChange}
      size="sm"
      header="Refuser le dossier"
      subtitle="La candidature sera déplacée dans les candidats archivés."
    >
      <ModalDialogBody className={styles.content}>
        <Text>
          Souhaitez-vous informer le candidat du refus de sa candidature par
          e-mail ?
        </Text>
        <Callout variant="info">
          L'e-mail envoyé utilise le modèle « Candidature refusée »,
          personnalisable depuis les modèles de mails de Mon Compte.
        </Callout>
      </ModalDialogBody>
      <ModalDialogFooter>
        <Button
          type="button"
          variant="secondary"
          disabled={submitting}
          onClick={() => confirm(false)}
        >
          Refuser sans e-mail
        </Button>
        <Button
          type="button"
          isLoading={submitting}
          onClick={() => confirm(true)}
        >
          Refuser et informer par e-mail
        </Button>
      </ModalDialogFooter>
    </ModalDialog>
  );
}
